// eslint-disable-next-line import/prefer-default-export
export const getSpeakers = state => state.speakers.speakers;
